@import "../../../global/gx-ide-common.scss";
@import "../../../global/gx-ide-mixins.scss";
@import "../../../global/temporary-tokens-chameleon.scss";

:host {
  display: block;
}

.header {
  display: grid;
  grid-template-columns: 1fr min-content min-content;
  grid-template-areas:
    "label label label"
    "input cancel export";
  grid-gap: var(--spacing-gap-l);

  .label {
    grid-area: label;
  }
  .input {
    grid-area: input;
  }
  .cancel {
    grid-area: cancel;
  }
  .export {
    grid-area: export;
  }
}
